export class InboundPlantFilterOptionsLoad {
  public static readonly type = '[FilterOptions]  Inbound Plant Filter Options Load';
  constructor(public payload: string) {}
}

export class ShipToPlantFilterOptionsLoad {
  public static readonly type = '[FilterOptions]  ShipTo Plant Filter Options Load';
  constructor(public payload: string) {}
}

export class ConsigneePlantFilterOptionsLoad {
  public static readonly type = '[FilterOptions]  Consignee Plant Filter Options Load';
  constructor(public payload: string) {}
}

export class SapIdOptionsLoad {
  public static readonly type = '[FilterOptions]  S4 Sap Id Options Load';
  constructor(public payload: string) {}
}

export class BusinessUnitsOptionsLoad {
  public static readonly type = '[FilterOptions]  Business Units/GBs Options Load';
  constructor(public payload: string) {}
}

export class NetworkPartOptionsLoad {
  public static readonly type = '[FilterOptions]  Network Part Options Load';
  constructor(public payload: string) {}
}

export class ConsignorAddressOptionsLoad {
  public static readonly type = '[FilterOptions] Consignor Address Options Load';
  constructor(public payload: string) {}
}

export class FreightPayerOptionsLoad {
  public static readonly type = '[FilterOptions] Freight Payer Options Load';
  constructor(public payload: string) {}
}

export class SourceLocationsOptionsLoad {
  public static readonly type = '[FilterOptions] Source Locations Options Load';
  constructor(public payload: string) {}
}

export class DestinationLocationsOptionsLoad {
  public static readonly type = '[FilterOptions] Destination Locations Options Load';
  constructor(public payload: string) {}
}

export class PortOfLoadingOptionsLoad {
  public static readonly type = '[FilterOptions] Port Of Loading Options Load';
  constructor(public payload: string) {}
}

export class PortOfDischargeOptionsLoad {
  public static readonly type = '[FilterOptions] Port Of Discharge Options Load';
  constructor(public payload: string) {}
}
export class SapSystemsOptionsLoad {
  public static readonly type = '[FilterOptions] Sap Systems Options Load';
  constructor(public payload: string) {}
}

export class FilterOptionsInitialState {
  public static readonly type = '[FilterOptions] Set Initial State';
}
